import { notNullish } from "./nullish.mjs";
function hexToRgb(hex) {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const hex6Digits = hex.replace(
    shorthandRegex,
    (m, r2, g2, b2) => r2 + r2 + g2 + g2 + b2 + b2
  );
  const [_, r, g, b] = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex6Digits) ?? [];
  if (![r, g, b].every(notNullish)) {
    return { r: 0, g: 0, b: 0 };
  }
  return {
    r: parseInt(r, 16),
    g: parseInt(g, 16),
    b: parseInt(b, 16)
  };
}
function hexToRgbString(hex) {
  const { r, g, b } = hexToRgb(hex);
  return `${r}, ${g}, ${b}`;
}
export {
  hexToRgb,
  hexToRgbString
};
